import { INITIATIVE_ROW, TASK_ROW } from '@/constants/initiative'
import {
  getGoalPageRouteConfig,
  getInitiativePageRouteConfig,
  getKrPageRouteConfig
} from '@/utils/navigationConfigs'
import * as R from 'ramda'
import * as keymapService from '../services/keymapService/keymapService'
import scrollToElement from '@/utils/scrollToElement'
import GoalMixin from '../mixins/GoalMixin'

export default {
  mixins: [GoalMixin],
  methods: {
    toggleExpansion(expanded) {
      if (this.isTaskSelected()) {
        return
      }
      let selectedVueContainer = this.selectedGoalViewer()
      if (!selectedVueContainer) {
        const selectedItem = keymapService.selectedListItem(this.$el)
        if (selectedItem && selectedItem.__vue__) {
          selectedVueContainer = selectedItem.__vue__
        }
      }
      if (this.isInitiativeSelected()) {
        // initiative may lie outside goal viewer too, on Your work page
        const selectedItem = keymapService.selectedListItem(this.$el)
        selectedVueContainer = selectedItem.__vue__
      } else if (selectedVueContainer) {
        const selectedItem = keymapService.selectedListItem(selectedVueContainer.$el)
        const selectedItemName = R.path(['__vue__', '$options', 'name'], selectedItem)
        if (selectedItemName === 'kr-row' || selectedItemName === 'InitiativeRow') {
          selectedVueContainer = selectedItem.__vue__
        }
      }
      if (selectedVueContainer) {
        selectedVueContainer.expanded =
          typeof expanded === 'undefined' ? !selectedVueContainer.expanded : expanded
        setTimeout(() => selectedVueContainer.$el.classList.add('selected'), 100)
      }
    },
    expandItem(event) {
      event.preventDefault()
      this.toggleExpansion(true)
      /*
        We want to handle scrolling when animation of goal tab expansion is over,
        since scrollToElement needs the height of expanded tab.
       */
      setTimeout(() => {
        const selectedElement = this.selectedElement()
        selectedElement && scrollToElement(selectedElement)
      }, 300)
    },
    collapseItem(event) {
      event.preventDefault()
      this.toggleExpansion(false)
    },
    viewGoal(event) {
      event.preventDefault()
      let selectedVueContainer = this.selectedGoalViewer()
      if (!selectedVueContainer) {
        const selectedItem = keymapService.selectedListItem(this.$el)
        if (selectedItem && selectedItem.__vue__) {
          selectedVueContainer = selectedItem.__vue__
        }
      }
      if (this.isInitiativeSelected() || this.isTaskSelected()) {
        const selectedInitiativeElement = this.selectedElement()
        const selectedVueComponent =
          this.getInitiativeRowVue(selectedInitiativeElement, TASK_ROW) ||
          this.getInitiativeRowVue(selectedInitiativeElement, INITIATIVE_ROW)
        const location = getInitiativePageRouteConfig({
          orgId: this.orgId,
          initiativeId: selectedVueComponent.initiative.id
        })
        this.$router.push(location)
      } else if (selectedVueContainer) {
        const el = selectedVueContainer.$el
        const classList = Array.from(el.classList)
        const selectedKr =
          el.querySelector('.kr.selected') ||
          (['kr', 'selected'].every(c => classList.includes(c)) && el)
        const goalId = selectedVueContainer.goalId
        const params = { orgId: this.orgId }
        let location
        if (selectedKr) {
          location = getKrPageRouteConfig({
            ...params,
            krId: selectedKr.dataset.krId
          })
        } else {
          location = getGoalPageRouteConfig({
            ...params,
            goalId
          })
        }
        this.$router.push(location)
      }
    }
  }
}
